import React, {useEffect, useState} from 'react';
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {MenuItem} from "@material-ui/core";
import PoliciesService from "../../../services/PoliciesService";
import {toast, ToastContainer} from "react-toastify";
import Spinner from "reactjs-simple-spinner";
import PaymentsService from "../../../services/PaymentsService";


const initialPaymentObject = {
    payment_method: '',
    payment_channel: '',
    currency_id: '',
    amount: '',
    reference_number: "",
    "bank_name": "",
    "branch": "",
    "account_number": "",
    "account_name": ""
}

const AddPayment = (props) => {

    const [payment, setPayment] = useState(initialPaymentObject)
    const [loading, setLoading] = useState(false);
    const [policyNumber, setPolicyNumber] = useState('')
    const [policies, setPolicies] = useState([])
    const [policy, setPolicy] = useState({})
    const [policyHolder, setPolicyHolder] = useState({})


    useEffect(() => {
        setLoading(true)

        setPolicy({})
        setPayment(initialPaymentObject)
        setPolicyHolder({})
        //    get allPolicies
        PoliciesService.getAllPolicies()
            .then(response => {
                console.log("res: ", response)
                setPolicies(response.data.policies)
                setLoading(false)
            }).catch(err => {
            console.error(err)
            setPolicies([])
            setLoading(false)
        })

    }, [])

    const defaultProps = {
        options: policies,
        getOptionLabel: (option) => option.policy_number,
    };


    const handleChange = name => ({target: {value}}) => {
        setPayment({...payment, [name]: value})
    }

    const handleSearch = () => {
        setLoading(true);

        if (policyNumber === '' || policyNumber === undefined) {
            setLoading(false)
            toast.warning('Please provide a policy number');
            return
        }
        //    search for policy details by policyNumber
        PoliciesService.searchPolicy(policyNumber)
            .then(response => {
                console.log("res: ", response)
                if (response.status === 200) {
                    setPolicyNumber('')
                    setPayment(initialPaymentObject)
                    setPolicy(response.data.policy)
                    setPolicyHolder(response.data.policyHolder)
                    setLoading(false)
                }
            }).catch(err => {
            console.log("error: ", err)
            setPolicy({})
            setLoading(false);
            toast.warning('Network Error, Try again \nIf error persists contact System Administrator ');
            console.log('err: ', err)
        })

    }

    const handleSubmitPayment = () => {
        setLoading(true);
        console.log("id: ", policy.id)
        if (payment.amount === null || payment.amount === '') {
            setLoading(false);
            toast.warning('Please enter amount', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            return
        }


        if (policy.payment_method === 'CASH') {

            // noinspection BadExpressionStatementJS
            PaymentsService.addCashPayment(payment, policy.id)
                .then(res => {
                    console.log("res: ", res);
                    if (res.status === 200 || res.status === 201) {
                        setPolicy(res.data.policy)
                        setPayment(initialPaymentObject)
                        setLoading(false);
                        toast.success('Receipt Added Successfully!', {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                        });
                    } else {
                        setLoading(false)
                        toast.warning('Receipting failed, Please try again', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                }).catch(err => {
                console.log(err);
                setLoading(false)
                toast.warning('Receipting failed, Please try again \n Error: ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })
        } else {
            // noinspection BadExpressionStatementJS
            PaymentsService.addDebitPayment(payment, policy.id)
                .then(res => {
                    console.log("res: ", res);
                    if (res.status === 200 || res.status === 201) {
                        setPolicy(res.data.policy)
                        setPayment(initialPaymentObject)
                        setLoading(false);
                        toast.success('Receipt Added Successfully!', {
                            position: "top-right",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                        });
                    } else {
                        setLoading(false)
                        toast.warning('Receipting failed, Please try again', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                }).catch(err => {
                console.log(err);
                setLoading(false)
                toast.warning('Receipting failed, Please try again \n Error: ' + err.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            })
        }

    }

    const handleChangePolicyNumber = (e, v, name) => {
        if (v.policy_number === null || v.policy_number === undefined) {
            console.log(v.policy_number)
            setPolicyNumber('')
        } else {
            console.log(v.policy_number)
            setPolicyNumber(v.policy_number)
        }

    }


    return (
        <div>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
              <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                             &nbsp;|&nbsp;
                            <Link to="/payments"><a href><i className="fa fa-credit-card"/>&nbsp;Receipts</a> </Link>
                             &nbsp;|&nbsp;
                            <i className="fa fa-money"/>&nbsp;New Receipt
                        </ul>
                        {loading && (
                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                <Spinner
                                    size="medium"
                                    message="Please wait....."
                                    line-fg-color="#64c3c2"
                                />
                            </div>

                        )}
                        {!loading && (
                            <div className="row mt">
                                <div className="card col-lg-12">
                                    <div className="content-panel bg-white p-3">
                                        <div className="row">
                                            <div className="col-md-3">
                                                <Autocomplete
                                                    {...defaultProps}
                                                    id="auto-complete"
                                                    autoComplete
                                                    onChange={(e, v) => handleChangePolicyNumber(e, v, props.name)}
                                                    includeInputInList
                                                    renderInput={(params) =>
                                                        <TextField {...params} label="Search Policy By PolicyNumber"
                                                                   margin="normal" fullWidth
                                                        />}
                                                />
                                            </div>
                                            <div className="col-md-3">
                                                <button onClick={handleSearch} className="btn btn-sm btn-primary">
                                                    <i className="fa fa-search"/>&nbsp;
                                                    Search Policy Details
                                                </button>
                                            </div>
                                        </div>
                                        <hr/>
                                        <div className="row mt-5">
                                            <h4 className="col-md-12 font-weight-bold text-capitalize">Policy
                                                Details</h4>
                                        </div>
                                        <hr/>
                                        <div className="row mt-2">
                                            <div className="col-md-2">
                                                <h5><b>Policy Number:</b> <span>
                                                {policy.policy_number}
                                            </span>
                                                </h5>
                                            </div>
                                            <div className="col-md-2">
                                                <h5><b>Product:</b> <span>
                                                {policy.policy_type}
                                            </span>
                                                </h5>
                                            </div>
                                            <div className="col-md-2">
                                                <h5><b>Currency:</b> <span>
                                                {policy.policy_currency}
                                            </span>
                                                </h5>
                                            </div>
                                            <div className="col-md-2">
                                                <h5><b>Policy Holder:</b> <span>
                                                {policyHolder.first_name} {policyHolder.last_name}
                                            </span>
                                                </h5>
                                            </div>
                                            <div className="col-md-2">
                                                <h5><b>Payment Method:</b> <span>
                                                {policy.payment_method}
                                            </span>
                                                </h5>
                                            </div>
                                        </div>
                                        <div className="row mt-2">
                                            {policy.policy_type !== 'SAVINGS' && policy.policy_type !== 'PFUMA / INOTHO' && (
                                            <div className="col-md-2">
                                                <h5><b>Sum Assured:</b> <span>
                                                {policy.sum_assured}
                                            </span>
                                                </h5>
                                            </div>
                                                )}
                                            <div className="col-md-2">
                                                <h5><b>Premium:</b> <span>
                                                {policy.total_premium}
                                            </span>
                                                </h5>
                                            </div>
                                            <div className="col-md-2">
                                                <h5><b>Next Invoicing Date:</b> <span>
                                                {policy.next_invoicing_date}
                                            </span>
                                                </h5>
                                            </div>
                                            <div className="col-md-2">
                                                <h5><b>Partial Payment:</b> <span>
                                                {policy.balance}
                                            </span>
                                                </h5>
                                            </div>
                                            <div className="col-md-2">
                                                <h5><b>Arrear Balance:</b> <span>
                                                {policy.arrearBalance}
                                            </span>
                                                </h5>
                                            </div>
                                        </div>
                                        <hr/>
                                        {policy.payment_method == 'CASH' ? (
                                            <div className="row mt-3">

                                                <div className="col-md-3">
                                                    <TextField
                                                        select
                                                        onChange={handleChange('payment_channel')}
                                                        name="paymentChannel"
                                                        fullWidth
                                                        required
                                                        label="Select Payment Channel"
                                                    >
                                                        <MenuItem value disabled={true}>Select Payment
                                                            Channel</MenuItem>
                                                        <MenuItem value="CASH">Cash</MenuItem>
                                                        <MenuItem value="ECOCASH">Ecocash</MenuItem>
                                                        <MenuItem value="ONEMONEY">One Money</MenuItem>
                                                        <MenuItem value="TELECASH">Telecash</MenuItem>
                                                        <MenuItem value="RTGS">RTGS</MenuItem>
                                                        <MenuItem value="ZIPIT">ZIPIT</MenuItem>
                                                    </TextField>

                                                </div>

                                                <div className="col-md-3">

                                                    <TextField
                                                        margin="dense"
                                                        label="Amount"
                                                        type="text"
                                                        fullWidth
                                                        required
                                                        value={payment.amount}
                                                        onChange={handleChange('amount')}
                                                    />

                                                </div>
                                                <div className="col-md-3">
                                                    <TextField
                                                        onChange={handleChange('reference_number')}
                                                        name="reference_number"
                                                        fullWidth
                                                        label="Reference Number"
                                                    />

                                                </div>

                                            </div>
                                        ) : policy.payment_method == 'DEBIT_ORDER' ? (
                                            <div className="row mt-3">

                                                <div className="col-md-3">
                                                    <TextField
                                                        margin="dense"
                                                        label="Bank"
                                                        type="text"
                                                        fullWidth
                                                        required
                                                        value={payment.bank_name}
                                                        onChange={handleChange('bank_name')}
                                                    />

                                                </div>
                                                <div className="col-md-3">
                                                    <TextField
                                                        margin="dense"
                                                        label="Branch"
                                                        type="text"
                                                        fullWidth
                                                        required
                                                        value={payment.branch}
                                                        onChange={handleChange('branch')}
                                                    />

                                                </div>

                                                <div className="col-md-3">
                                                    <TextField
                                                        margin="dense"
                                                        label="Account Number"
                                                        type="text"
                                                        fullWidth
                                                        required
                                                        value={payment.account_number}
                                                        onChange={handleChange('account_number')}
                                                    />

                                                </div>
                                                <div className="col-md-3">
                                                    <TextField
                                                        margin="dense"
                                                        label="Account Holder"
                                                        type="text"
                                                        fullWidth
                                                        required
                                                        value={payment.account_name}
                                                        onChange={handleChange('account_name')}
                                                    />

                                                </div>

                                                <div className="col-md-3">

                                                    <TextField
                                                        margin="dense"
                                                        label="Amount"
                                                        type="text"
                                                        fullWidth
                                                        required
                                                        value={payment.amount}
                                                        onChange={handleChange('amount')}
                                                    />

                                                </div>
                                                <div className="col-md-3">
                                                    <TextField
                                                        margin="dense"
                                                        label="Reference Number"
                                                        type="text"
                                                        fullWidth
                                                        required
                                                        value={payment.reference_number}
                                                        onChange={handleChange('reference_number')}
                                                    />

                                                </div>

                                            </div>
                                        ) : policy.payment_method == 'STOP_ORDER' ? (
                                            <div className="row mt-3">

                                                <div className="container col-md-3">
                                                    <a href={'/bulk-payments'} className="btn btn-sm btn-warning">
                                                        <i className="fa fa-info"></i>&nbsp; Go to Stop Order Payments
                                                        Page
                                                    </a>
                                                </div>

                                            </div>
                                        ) : (
                                            <div className="row mt-3">

                                            </div>
                                        )}
                                        <div className="row mt-3">
                                            <div className="col-md-4">
                                                <button onClick={handleSubmitPayment}
                                                        className="btn btn-sm btn-primary">
                                                    <i className="fa fa-send"/>&nbsp;
                                                    Submit
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddPayment;
